import { isAuth } from '@/services/PermissionService';
import Content from '@/components/layout/Content';
import Names from './names';
import { FINANCE, hasPermission, OWNER, POS_BUSINESS_FINANCE, SUPER_ADMIN } from '@/middlewares/permissions';

export default {
	path: '/',
	component: Content,
	children: [
		{
			path: '/',
			redirect: '/orders/kanban',
		},
		{
			path: 'home',
			name: Names.Home,
			component: () => import('../views/HomeView'),
			meta: {
				title: 'Home',
				middleware: [isAuth],
			},
		},
		{
			path: 'change-password',
			name: Names.ChangePassword,
			component: () => import('../views/ChangePassword'),
			meta: {
				title: 'Change Password',
				middleware: [isAuth],
			},
		},
		{
			path: 'dashboard',
			name: Names.Dashboard,
			component: () => import('../views/Dashboard'),
			meta: {
				title: 'Dashboard',
				middleware: [
					isAuth,
					(nav) => hasPermission(nav, [POS_BUSINESS_FINANCE], [SUPER_ADMIN, OWNER, FINANCE]),
				],
			},
		},
		{
			path: 'notificationLanding',
			name: Names.NotificationLanding,
			component: () => import('../views/NotificationLanding'),
			meta: {
				middleware: [isAuth],
			},
		},
	],
};
